import styled from "styled-components";

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%; 
   
`;
export const HistoryContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;  
    height: calc(100vh - 324px);
    min-height: 0;    
    overflow-y: auto;    
    border-radius: 8px;
`;

export const ItemContainerChatHistory = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: flex-start;
    width: 100%;

`;


export const ItemChatSend = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    background-color: #F6F9FF;
    padding: 12px;
    border-radius: 8px;
    flex: 1;
`;

export const ItemChatReceive = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    background-color: #FAFAFA;
    padding: 12px;
    border-radius: 8px;
    flex: 1;
`;

export const SummaryCardContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const SummaryCardHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;
export const SummaryHeaderLeftContainer = styled.div`
    display: flex;
    gap: 4px;
`;

export const DateDivider = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 0;
    margin: 8px 0;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        height: 1px;
        z-index: 1;
    }
`;

export const DateLabel = styled.div`    
    color: #6B7280;  
    
`;

